<template>
  <TirPmModal :is-visible="isVisible" :title="title" :is-with-back="false" @close="onCancelExit">
    <template #content> Если выйти сейчас, введенные данные не сохранятся </template>
    <template #footer>
      <TirPmButton
        :size="TirPmButtonSizeEnum.Regular"
        :variant="TirPmButtonVariantEnum.PrimaryState"
        @click="onCancelExit"
      >
        <div style="padding: 0 0.5rem">Вернуться к редактированию</div>
      </TirPmButton>
      <TirPmButton
        :size="TirPmButtonSizeEnum.Regular"
        :variant="TirPmButtonVariantEnum.LinkState"
        @click="onExit"
      >
        <div style="padding: 0 0.688rem">Выйти</div>
      </TirPmButton>
    </template>
  </TirPmModal>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmModal,
} from "tir-components";

const emit = defineEmits<{
  /**Событие выхода */
  (e: "exit"): void;
  /**Событие отмены выхода */
  (e: "cancelExit"): void;
}>();

const props = defineProps({
  /**Заголовок */
  title: {
    type: String,
    default: "Отменить создание?",
  },
});

/**Видимость модального окна */
const isVisible = ref(false);
/**Открыть модальное окно */
const open = () => (isVisible.value = true);
/**Закрыть модальное окно */
const close = () => (isVisible.value = false);

/**При выходе */
const onExit = () => {
  close();
  emit("exit");
};

/**При отмене выхода */
const onCancelExit = () => {
  close();
  emit("cancelExit");
};

defineExpose({
  open,
});
</script>

<style lang="scss" scoped></style>
